function callBack (el, { value }) {
  const money = Number(value) / 100 + '' // 获取到的金额单位是 '分'
  const beforePoint = money.split('.')[0]
  const afterPoint = money.split('.')[1] || '00'
  el.innerHTML = `${beforePoint}<i class="point">.${afterPoint}</i>`
}

export default {
  inserted: callBack,
  update: callBack
}
